import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
  Image,
  useDisclosure,
  Flex,
  Text,
} from '@chakra-ui/react';
import { List } from 'phosphor-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Options from './Options';
import { useAuth } from '../../providers/auth';
import { MODULOS_SIDEBAR, ModuloTile, isModuloAtivo } from './modulos';
import logo from '../../assets/brand/logo-horizontal-color.svg';

export function ResponsiveMenu() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, isAdmin } = useAuth();

  const OpenRoutes = MODULOS_SIDEBAR.filter(route => isAdmin() || hasPermission(route.path));

  return (
    <>
      <IconButton
        ref={btnRef}
        aria-label="Abrir menu"
        icon={<List size={22} weight="bold" />}
        variant="ghost"
        color="#475569"
        borderRadius="full"
        _hover={{ bg: '#F1F5F9', color: '#0F172A' }}
        onClick={onOpen}
      />
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay bg="rgba(15, 23, 42, 0.25)" />
        <DrawerContent bg="white" borderRightRadius="24px" overflow="auto">
          <DrawerCloseButton top={4} />
          <DrawerHeader pb={2}>
            <Image src={logo} alt="Especialistas Inteligência Contábil" h="30px" w="auto" />
          </DrawerHeader>

          <DrawerBody px={3} pt={2}>
            <Options isOpen handleClose={onClose} />

            <Text
              px={3}
              mt={5}
              mb={2}
              fontSize="10.5px"
              fontWeight={700}
              letterSpacing="0.14em"
              textTransform="uppercase"
              color="#94A3B8"
            >
              Módulos
            </Text>
            <Flex direction="column" gap="2px">
              {OpenRoutes.map(item => {
                const ativo = isModuloAtivo(item.path, location.pathname);
                return (
                  <Flex
                    key={item.path}
                    as="button"
                    type="button"
                    align="center"
                    gap={3}
                    w="full"
                    p="6px"
                    pr={3}
                    borderRadius="14px"
                    bg={ativo ? '#EAF4FF' : 'transparent'}
                    _hover={{ bg: ativo ? '#E1EFFF' : '#F5F8FB' }}
                    onClick={() => {
                      navigate(item.path);
                      onClose();
                    }}
                  >
                    <ModuloTile modulo={item} ativo={ativo} />
                    <Text
                      fontSize="13px"
                      fontWeight={ativo ? 700 : 500}
                      color={ativo ? '#1B88F5' : '#334155'}
                    >
                      {item.name}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
